import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/lib/api";

const NAV = [
  { label: "HOME", to: "/" },
  { label: "EVENTS", to: "/events" },
  { label: "VENUES", to: "/venues" },
  { label: "ABOUT ABE", to: "/about" },
  { label: "CONTACT", to: "/contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [open]);

  return (
    <>
      <header
        data-testid="site-header"
        className="sticky top-0 z-50 bg-white border-b border-black/5 shadow-sm"
      >
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 sm:px-6 h-16">
          <Link to="/" data-testid="logo-link" className="flex items-center">
            <img src={LOGO_URL} alt="ABE — Absolutely Business Entertainment" className="h-9 sm:h-10 w-auto" />
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`font-oswald text-sm font-semibold tracking-wide transition-colors ${
                  location.pathname === n.to ? "text-[#D4AF37]" : "text-black hover:text-[#D4AF37]"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              data-testid="header-tickets-btn"
              onClick={() => navigate("/events")}
              className="hidden sm:inline-flex btn-gold rounded-md px-4 py-2 font-oswald text-sm tracking-wide"
            >
              GET TICKETS
            </button>
            <button
              data-testid="menu-toggle"
              onClick={() => setOpen((o) => !o)}
              className="md:hidden inline-flex items-center justify-center rounded-md p-1.5 text-black"
              aria-label="Menu"
            >
              {open ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>
      </header>

      {open && (
        <div className="fixed inset-0 top-16 z-40 md:hidden bg-[#09090B]" data-testid="mobile-menu">
          <nav className="flex flex-col px-6 py-8 gap-1">
            {NAV.map((n, i) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="font-display text-4xl uppercase text-white py-3 border-b border-white/10 fade-up"
                style={{ animationDelay: `${i * 40}ms` }}
              >
                {n.label}
              </Link>
            ))}
            <button
              data-testid="mobile-tickets-btn"
              onClick={() => navigate("/events")}
              className="btn-gold mt-6 rounded-md py-4 font-oswald text-base tracking-widest"
            >
              GET TICKETS
            </button>
          </nav>
        </div>
      )}
    </>
  );
}
